import { Box, IconButton, Popover } from "@mui/material";
import type { JSX } from "react";

const QUICK_EMOJI = [
  "👍", "🙏", "🎉", "🔥", "✅", "👀", "😄", "😅",
  "😂", "🙂", "😍", "🤝", "💯", "🚀", "👏", "❤️",
  "🤔", "😎", "👋", "💪", "🙌", "✨", "⚡", "📌",
];

/** Quick-emoji grid popover anchored to the composer's emoji button. Extracted
 * from `ChatComposer.tsx`. */
export function EmojiPopover({
  anchorEl,
  onClose,
  onPick,
}: {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  onPick: (emoji: string) => void;
}): JSX.Element {
  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "left" }}
      transformOrigin={{ vertical: "bottom", horizontal: "left" }}
    >
      <Box sx={{ display: "grid", gridTemplateColumns: "repeat(8, 1fr)", gap: 0.5, p: 1, maxWidth: 320 }}>
        {QUICK_EMOJI.map((e) => (
          <IconButton key={e} size="small" onClick={() => onPick(e)} sx={{ fontSize: 20 }} aria-label={`Insert ${e}`}>
            {e}
          </IconButton>
        ))}
      </Box>
    </Popover>
  );
}
